import React from "react";

import { LoaderWrapper, LoaderInner } from "./styles";

const Loader = () => (
  <LoaderWrapper>
    <LoaderInner />
  </LoaderWrapper>
);

export default Loader;
